module.exports = __webpack_public_path__ + "img/selected1-min.aed335bd.png";